import { useEffect, useState } from 'react'
import { colorPalet } from '../colorPaletFromGraphics';
import { FormatMoney } from '../../formatMoney'

import { Container, BarData, Bar } from './style'

export function GenericHorizontalBar({ datasForGraphic }) {
    const [animationBar, setAnimationBar] = useState(false);


    useEffect(() =>{
        setTimeout(() =>{
            setAnimationBar(true)
        }, 50) 
    }, [])


    return(
        <Container>
           {datasForGraphic.map((data, index) => (
                <BarData 
                    key={index} 
                    animationBar={animationBar}
                >

                    <strong>{data.name}</strong>
                    <Bar percent={data.percent} animationBar={animationBar} color={colorPalet[index]}>
                        {data.percent >= 70 ?
                            <FormatMoney value={data.value}/>
                            : 
                            <></>
                        }
                    </Bar>

                    {data.percent < 70 ?
                        <FormatMoney value={data.value}/>
                        : 
                        <></>
                    }
                </BarData>
           ))}
        </Container>
    )
}